<template>
<div class="chapter">
<div class="inner_page">
<div id="x01d_Neal_contents.html" xml:lang="en-US">
<div class="Opener">
<p class="FM-Contents-Title"><a id="pagev">Contents</a></p><a id="pagev">
</a><p class="FM-Contents-Front"><a id="pagev"></a><a href="#/01e_Neal_preface#pagevii">Preface</a></p>
<p class="FM-Contents-Front-Last"><a href="#/01f_Neal_ack#pagexi">Acknowledgments</a></p>
<p class="FM-Contents-Part-Part-Num">Part One</p>
<p class="FM-Contents-Part-Title">Mogul Style</p>
<p class="FM-Contents"><a href="#/03_Neal_1#page3">1: Six Women and Six Men</a></p>
<p class="FM-Contents"><a href="#/04_Neal_2#page9">2	BA 0.043</a></p>
<p class="FM-Contents"><a href="#/05_Neal_3#page13">3: 950 Fifth Avenue</a></p>
<p class="FM-Contents"><a href="#/06_Neal_4#page21">4: Executive Perquisites</a></p>
<p class="FM-Contents"><span href="#/07_Neal_5#page29" title="Link target outside of Sample">5: Behind the Elephant</span></p>
<p class="FM-Contents"><span href="#/08_Neal_6#page35" title="Link target outside of Sample">6: Becoming CEO</span></p>
<p class="FM-Contents-Part-Part-Num">Part Two</p>
<p class="FM-Contents-Part-Title">Timing Is Everything</p>
<p class="FM-Contents"><span href="#/10_Neal_7#page51" title="Link target outside of Sample">7: Big Time Scrutiny</span></p>
<p class="FM-Contents"><span href="#/11_Neal_8#page61" title="Link target outside of Sample">8: The Good Old Days</span></p>
<p class="FM-Contents"><span href="#/12_Neal_9#page73" title="Link target outside of Sample">9: Extraordinary Times</span></p>
<p class="FM-Contents"><span href="#/13_Neal_10#page79" title="Link target outside of Sample">10: You Say You Want a Resolution</span></p>
<p class="FM-Contents"><span href="#/14_Neal_11#page85" title="Link target outside of Sample">11: When the CIT Hit the Fan</span></p>
<p class="FM-Contents"><span href="#/15_Neal_12#page95" title="Link target outside of Sample">12: “Oh God, what now?”</span></p>
<p class="FM-Contents-Part-Part-Num">Part Three</p>
<p class="FM-Contents-Part-Title">Ring around the White-Collar of Criminal Justice</p>
<p class="FM-Contents"><span href="#/17_Neal_13#page109" title="Link target outside of Sample">13: “<span class="FM-Contents-Italic">Pour encourager les autres</span>”</span></p>
<p class="FM-Contents"><span href="#/18_Neal_14#page121" title="Link target outside of Sample">14: Internal Investigation</span></p>
<p class="FM-Contents"><span href="#/19_Neal_15#page135" title="Link target outside of Sample">15: <span class="FM-Contents-Italic">People v. Kozlowski I</span></span></p>
<p class="FM-Contents"><a id="pagevi"></a><span href="#/20_Neal_16#page153" title="Link target outside of Sample">16: <span class="FM-Contents-Italic">People v. Kozlowski II</span></span></p>
<p class="FM-Contents"><span href="#/21_Neal_17#page181" title="Link target outside of Sample">17: Cut from Whole Cloth</span></p>
<p class="FM-Contents-Part-Part-Num">Part Four</p>
<p class="FM-Contents-Part-Title">Inglorious Ending</p>
<p class="FM-Contents"><span href="#/23_Neal_18#page191" title="Link target outside of Sample">18: 05A4820</span></p>
<p class="FM-Contents"><span href="#/24_Neal_19#page211" title="Link target outside of Sample">19: Observations</span></p>
<p class="FM-Contents-Rear-First"><span href="#/25_Neal_notes#page229" title="Link target outside of Sample">Notes</span></p>
<p class="FM-Contents-Rear"><span href="#/26_Neal_biblio#page251" title="Link target outside of Sample">Bibliography</span></p>
<p class="FM-Contents-Rear"><span href="#/27_Neal_index#page259" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01d_Neal_contents.vue?4f473114